module.exports = __webpack_public_path__ + "img/head.0dbd43d2.png";